import React from 'react';
import { PropertyGroup } from './PropertyGroup';

/**
 * Hidden Field Property - Allows setting default value or current date/time
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HiddenFieldProperty = _ref => {
  let {
    field,
    updateField,
    selectedField
  } = _ref;
  if (field.type !== 'hidden') {
    return null;
  }

  // Determine the current mode: 'default' or 'currentDateTime'
  const useCurrentDateTime = field.useCurrentDateTime === true;
  const handleModeChange = useDateTime => {
    if (useDateTime) {
      // When switching to current date/time, clear the default value
      updateField(selectedField, {
        useCurrentDateTime: true,
        defaultValue: undefined
      });
    } else {
      // When switching to default value, clear the useCurrentDateTime flag
      updateField(selectedField, {
        useCurrentDateTime: false
      });
    }
  };
  return /*#__PURE__*/_jsxs(PropertyGroup, {
    label: "Value",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "property-item property-item-spacing",
      children: [/*#__PURE__*/_jsx("label", {
        className: "property-label",
        children: "Value Type"
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem'
        },
        children: [/*#__PURE__*/_jsxs("label", {
          className: "checkbox-label",
          children: [/*#__PURE__*/_jsx("input", {
            type: "radio",
            name: `hidden-value-type-${selectedField}`,
            checked: !useCurrentDateTime,
            onChange: () => handleModeChange(false)
          }), /*#__PURE__*/_jsx("span", {
            children: "Default Value"
          })]
        }), /*#__PURE__*/_jsxs("label", {
          className: "checkbox-label",
          children: [/*#__PURE__*/_jsx("input", {
            type: "radio",
            name: `hidden-value-type-${selectedField}`,
            checked: useCurrentDateTime,
            onChange: () => handleModeChange(true)
          }), /*#__PURE__*/_jsx("span", {
            children: "Current Date/Time"
          })]
        })]
      })]
    }), !useCurrentDateTime && /*#__PURE__*/_jsxs("div", {
      className: "property-item property-item-spacing",
      children: [/*#__PURE__*/_jsx("label", {
        className: "property-label",
        children: "Default Value"
      }), /*#__PURE__*/_jsx("input", {
        type: "text",
        value: field.defaultValue || '',
        onChange: e => updateField(selectedField, {
          defaultValue: e.target.value
        }),
        className: "property-input",
        placeholder: "Enter default value"
      }), /*#__PURE__*/_jsx("p", {
        className: "help-text",
        children: "This value will be used when the form is loaded"
      })]
    }), useCurrentDateTime && /*#__PURE__*/_jsx("div", {
      className: "property-item property-item-spacing",
      children: /*#__PURE__*/_jsxs("p", {
        className: "help-text",
        children: ["The field will automatically be set to the current date and time when the customer fills the form.", /*#__PURE__*/_jsx("br", {}), "Format: ISO 8601 (e.g., \"2024-01-15T14:30:00.000Z\")"]
      })
    })]
  });
};